const useLocalStorage = () => {
  const storageKeys = {
    randomId: "el-rayo-random-id",
    medataFiles: "el-rayo-metadata-files",
  };

  const getLocalStorageItem = (key: string) => localStorage.getItem(key);
  const getSessionStorageItem = (key: string) => sessionStorage.getItem(key);

  const getLocalStorageJson = (key: string) => {
    const data: any = getLocalStorageItem(key);

    if (data) {
      return JSON.parse(data);
    }

    return null;
  };

  const getSessionStorageJson = (key: string) => {
    const data: any = getSessionStorageItem(key);

    if (data) {
      return JSON.parse(data);
    }

    return null;
  };

  const setLocalStorageItem = (key: string, data: string) =>
    localStorage.setItem(key, data);

  const setSessionStorageItem = (key: string, data: string) =>
    sessionStorage.setItem(key, data);

  const setLocalStorageJson = (key: string, data: any) =>
    setLocalStorageItem(key, JSON.stringify(data));

  const setSessionStorageJson = (key: string, data: any) =>
    setSessionStorageItem(key, JSON.stringify(data));

  const clearLocalStorage = () => {
    localStorage.removeItem(storageKeys.randomId);
    localStorage.removeItem(storageKeys.medataFiles);
  };

  const clearSessionStorage = () => {
    sessionStorage.removeItem(storageKeys.randomId);
    sessionStorage.removeItem(storageKeys.medataFiles);
  };

  return {
    storageKeys,
    getLocalStorageItem,
    getSessionStorageItem,
    getLocalStorageJson,
    getSessionStorageJson,
    setLocalStorageItem,
    setSessionStorageItem,
    setLocalStorageJson,
    setSessionStorageJson,
    clearLocalStorage,
    clearSessionStorage,
  };
};

export default useLocalStorage;
